export default __webpack_public_path__ + "static/media/info-tooltip.33ccb49a.svg";